import { render, staticRenderFns } from "./news_info_popup.vue?vue&type=template&id=b21adf26&"
import script from "./news_info_popup.vue?vue&type=script&lang=js&"
export * from "./news_info_popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports